import React from 'react';
import { NavMenu, PageId } from './NavMenu';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  currentPage: PageId;
  onPageChange: (page: PageId) => void;
}

export const MobileMenu: React.FC<MobileMenuProps> = (props) => {
  return <NavMenu {...props} mobileOnly />;
};
